<template>
    <div class="financial-bill parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <Breadcrumb />
        <h1>帳單列表</h1>
        <div class="btn-group">
            <table-search @changeWord="setFilterWord" ></table-search>
            <div class="filter" @click="openFilter()">
                <img src="@/assets/img/icon/filter_white.svg" alt="">
            </div>
        </div>
        <financial-bill-filter :isOpen="isFilter" @filterClose="closeFilter" @changeFilter="setFilterQuery"></financial-bill-filter>
        <tabs :key="componentKey">
            <tab name="全部" :selected="selected.all" >
                <financial-bill-list state="ALL"></financial-bill-list>
            </tab>
            <tab name="欠款" :selected="selected.arrears" >
                <financial-bill-list state="OVERDUE"></financial-bill-list>
            </tab>
            <tab name="已繳" :selected="selected.paid" >
                <financial-bill-list state="COMPLETELY_PAID"></financial-bill-list>
            </tab>
            <tab name="未繳" :selected="selected.unpaid" >
                <financial-bill-list state="UNPAID"></financial-bill-list>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import financialBillList from '@/components/landlord/financialManagement/financialBillList.vue';
import financialBillFilter from '@/components/landlord/financialManagement/financialBillFilter.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { mapGetters } from 'vuex'
export default {
    name: 'TenantManagement',
    data () {
        return {
            hash: null,
            myHeight: (window.innerHeight) + 'px',
            listIsFixed: false,
            isFilter: false,
            selected: {
                all: false,
                arrears: false,
                paid: false,
                unpaid: false,
            },
            componentKey: 0,
        }
    },
    created (){
        this.selectTabByHash()
    },
    mounted () {
        this.$analytics.logEvent('帳單列表', { screen_name: '帳單列表'})
        window.addEventListener('scroll', this.handleScroll);
        this.$store.dispatch('getFinancialBillMgtList')
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.forceUpdate()
            },
            // immediate: true,
            deep: true
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#全部' ){
                this.$analytics.logEvent('帳單列表_全部', { screen_name: '帳單列表_全部'})
                this.selected.all = true
            }else if( hashTag == '#欠款' ){
                this.$analytics.logEvent('帳單列表_欠款', { screen_name: '帳單列表_欠款'})
                this.selected.arrears = true
            }else if( hashTag == '#未繳' ){
                this.$analytics.logEvent('帳單列表_未繳', { screen_name: '帳單列表_未繳'})
                this.selected.unpaid = true
            }else if( hashTag == '#已繳' ){
                this.$analytics.logEvent('帳單列表_已繳', { screen_name: '帳單列表_已繳'})
                this.selected.paid = true
            }else{
                this.$analytics.logEvent('帳單列表_全部', { screen_name: '帳單列表_全部'})
                this.selected.all = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.all = false
            this.selected.arrears = false
            this.selected.unpaid = false
            this.selected.paid = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        },
        openFilter: function () {
            this.isFilter = true
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
        },
        closeFilter: function (value) {
            this.isFilter = value
            this.$store.commit('modalStatus/set_filter_mode', false)
        },
        setFilterWord: function (value) {
            this.$store.dispatch('setFinancialBillFilterWord', value)
        },
        setFilterQuery: function (value) {
            console.log(value)
            this.$store.dispatch('setFinancialBillFilterQuery', value)
        },
    },
    computed: {
        ...mapGetters({
            isModalMode: 'GET_MODAL_MODE'
        })
    },
    components: {
        financialBillList,
        financialBillFilter,
        TableSearch,
        Breadcrumb,
        Tabs,
        Tab
    }
}
</script>
<style lang="scss">
    .financial-bill{
        position: relative;
        margin-top: 123px;
        .breadcrumb{
            position: absolute;
            top: -43px;
        }
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
        >.btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: 4px;
            right: 20px;
            .new-accounting-btn{
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                width: 120px;
                padding: 10px 0;
                margin-right: 16px;
                font-weight: 500;
            }
            .filter{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 44px;
                height: 44px;
                cursor: pointer;
                background: #a8a5a4;
                border-radius: 4px;
                margin-left: 16px;
            }
        }
        .tabs{
            position: absolute;
            top: 3px;
            left: 150px;
            ul li.is-active :after{
                bottom: -4px;
            }
        }
    }
    .financial-bill.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        // >h1{
        //     position: fixed;
        //     top: -5px;
        //     z-index: 8;
        // }
        >.btn-group{
            position: fixed;
            top: 18px;
            right: unset;
            z-index: 8;
            margin-left: 727px;
        }
        .tabs{
            position: fixed;
            margin-left: 0px;
            top: 27px;
            left: unset;
            z-index: 8;
        }
        .tabs-details{
            position: relative;
            padding-top: 59px;
            border-radius: 0 0 10px 10px;
        }
    }
    @media screen and (max-width: 1280px){
        .financial-bill{
            
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/financialManagementPages/financialBill.vue